// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "upgradeFlightClass-3r653";
var _5 = "aggregatorUpgrade-2ghGV";
var _6 = "aggregatorCover-19nrp";
var _7 = "paper-3rOuf";
var _8 = "top_wrapper-1UY7l";
var _9 = "content-2r886";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "upgradeFlightClass", _5 as "aggregatorUpgrade", _6 as "aggregatorCover", _7 as "paper", _8 as "top_wrapper", _9 as "content" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "upgradeFlightClass": _4, "aggregatorUpgrade": _5, "aggregatorCover": _6, "paper": _7, "top_wrapper": _8, "content": _9 }
